export const GET_STRESS_ECHO_DOCUMENT = 'GET_STRESS_ECHO_DOCUMENT'
export const STRESS_ECHO_DOC_LOADING = 'STRESS_ECHO_DOC_LOADING'
export const RESET_STRESS_ECHO_MODAL = 'RESET_STRESS_ECHO_MODAL'
export const CLEAR_STRESS_ECHO = 'CLEAR_STRESS_ECHO'
export const STRESS_ECHO_GXT_TRIGGER = 'STRESS_ECHO_GXT_TRIGGER'
